import useIsMarketingBannersEnabled from "../MarketingImage/hooks";
import useWelcomeOffer from "./useWelcomeOffer";

const useIsMarketingCardVisible = (): boolean => {
  const isMarketingBannersEnabled = useIsMarketingBannersEnabled();
  const welcomeOffer = useWelcomeOffer();
  return Boolean(welcomeOffer) || isMarketingBannersEnabled;
};

export default useIsMarketingCardVisible;
